import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import tagsView from './modules/tagsView'
import permission from './modules/permission'
import settings from './modules/settings'
import baseurl from './modules/baseurl'
import getters from './getters'
import pagestatus from './modules/pagestatus'
import comments from './modules/comments'
import dicts from './modules/dicts'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    tagsView,
    permission,
    settings,
    pagestatus,
    baseurl,
    comments,
    dicts
  },
  getters
})
//获得app、评论数量
store.dispatch('pagestatus/updatePageStatus')
store.dispatch("dicts/getLinglongAppSupSys")
export default store
